<template>
  <div>
    <error-header-section :title="title" />
    <error-body-section :message="message" :descriptions="descriptions" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import ErrorHeaderSection from '@/components/ErrorPage/ErrorPane/ErrorHeaderSection.vue'
import ErrorBodySection from '@/components/ErrorPage/ErrorPane/ErrorBodySection.vue'

export default defineComponent({
  name: 'ErrorPagePane',
  components: {
    ErrorBodySection,
    ErrorHeaderSection,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    descriptions: {
      type: [],
      default: () => [],
    },
  },
})
</script>
